import { SuspensionDetailPrintModel } from "./suspension-detail-print-model";

export class SuspensionPrintModel {
    suspensionId: number = 0;
    enterpriseLogo: string | null = null;
    enterpriseNit: string = "";
    enterpriseName: string = "";
    branchName: string = "";
    consecutive: number = 0;
    suspensionState: string = "";
    branchAddress: string = "";
    branchPhone: string = "";
    dateSuspension: Date = new Date();
    costCenter: string = "";
    constructionSiteAddress: string = "";
    constructionSitePhone: string = "";
    constructionSiteClient: string = "";
    observation: string = "";
    userAuthenticated: string = "";
    suspensionDetails: SuspensionDetailPrintModel[] = [];
}